import { intersection, isEmpty } from 'lodash';

import { TICKET_TYPE } from '@/pages/Ticket/Ticket.constants';
import type { Watcher } from '@/pages/Ticket/Ticket.types';

export const getDefaultOrgWatchers = (
  watcherOptions: Watcher[],
  ticketPriority: number,
  ticketType: number,
  tags: string[] = []
) => {
  const defaultOrgWatchers: Watcher[] = [];
  watcherOptions.forEach((watcher) => {
    if (
      !isEmpty(watcher.notificationTags) &&
      !isEmpty(tags) &&
      intersection(watcher.notificationTags, tags).length > 0
    ) {
      defaultOrgWatchers.push(watcher);
    }

    if (
      ticketType === TICKET_TYPE.THREAT &&
      watcher.notificationTicketThreat &&
      watcher.notificationThreatPriority.includes(ticketPriority || 0)
    ) {
      defaultOrgWatchers.push(watcher);
    }

    if (
      ticketType === TICKET_TYPE.SERVICE &&
      watcher.notificationTicketService
    ) {
      defaultOrgWatchers.push(watcher);
    }
  });

  return defaultOrgWatchers;
};

export default getDefaultOrgWatchers;
